/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Button, InputGroup, Form, Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import * as actions from "../../../../redux/actions/artciles";
import { injectIntl } from "react-intl";
import { createPollOnPost } from "../../../../redux/actions/posts";

function PollCreatorDialog({ poll, show, onHide, intl, entity, editPost }) {
  const dispatch = useDispatch();
  const [votesPoll, setVotesPoll] = useState(0);
  const [pollOptionsInputs, setPollOptionsInputs] = useState([
    { key: "option-1", value: "" },
    { key: "option-2", value: "" },
  ]);

  const initialValues = {
    body: null,
    days: 0,
    options: null,
    hours: 0,
    minutes: 0,
    error:'',
    options: [
      { key: "option-1", value: "" },
      { key: "option-2", value: "" },
    ]
  };

  const [pollCreated, setPollCreated] = useState();

  useEffect(() => {
    if (poll) {
      let countVotes = 0;
      poll.options.map((item) => {
        const number = item?.votes ? item.votes : 0
        countVotes = countVotes + number;
      });
      setVotesPoll(countVotes);
      if(poll.expiration_date != undefined){
        const datePoll = new Date(poll.expiration_date);
        const today = new Date();
        const difference = datePoll.getTime() - today.getTime();
        setPollCreated({
          ...poll,
          days: Math.round(difference / (1000 * 60 * 60 * 24)),
          hours: datePoll.getHours() - today.getHours(),
          minutes: datePoll.getMinutes() - today.getMinutes(),
        });
      }else{
        setPollCreated({
          ...poll
        });
      }

      if (poll.options[0].description) {
        const optionsPoll = poll.options.map((item) => {
          return { key: item.id, value: item.description };
        });
        setPollOptionsInputs(optionsPoll);
      } else {
        setPollOptionsInputs(poll.options);
      }
    } else {
      setPollCreated({ ...initialValues });
      setPollOptionsInputs(initialValues.options);      
    }
  }, [poll]); // eslint-disable-line react-hooks/exhaustive-deps

  const MINUTES = Array.from({ length: 60 }, (v, k) => ({
    key: k,
    value: k,
  }));

  const DAYS = Array.from({ length: 8 }, (v, k) => ({
    key: k,
    value: k,
  }));

  const HOURS = Array.from({ length: 24 }, (v, k) => ({
    key: k,
    value: k,
  }));

  const addOptionInput = (e) => {
    e.preventDefault();
    setPollOptionsInputs([
      ...pollOptionsInputs,
      { key: `option-${pollOptionsInputs.length + 1}`, value: "" },
    ]);
  };

  const removeOptionInput = (e, input) => {
    e.preventDefault();
    let pos = pollOptionsInputs.indexOf(input);
    const options = new Array(...pollOptionsInputs);
    options.splice(pos, 1);
    setPollOptionsInputs([...options]);
  };

  const validateForm = () =>{
    if(pollCreated){
      if((pollCreated.body == undefined ) || (pollCreated.body.trim().length == 0)){
        setPollCreated({...pollCreated,error:'Text cannot be empty'});
        return false;
      }
      let options = pollOptionsInputs.filter((option) => {return option.value.trim().length > 0});
      if(options.length < 2){
        setPollCreated({...pollCreated,error:'Set at least 2 options'});
        return false;
      }

      if((( isNaN(pollCreated.days) || pollCreated.days == 0  ) && (isNaN(pollCreated.hours) || pollCreated.hours == 0  )) || (pollCreated.days == 7 && (pollCreated.hours > 0 || pollCreated.minutes > 0))){
        setPollCreated({...pollCreated,error:'Poll duration must be between 1 hour and 7 days'});
        return false;
      }
      
    }
    setPollCreated({...pollCreated,error:''});
    return  true;   
    
  }

  const renderOptionsInput = () => {
    return pollOptionsInputs.map((input) => (
      <InputGroup className="mb-3">
        <Form.Control
          disabled={votesPoll !== 0}
          key={input.key}
          type="text"
          value={input.value}
          onChange={(e) => {
            const value = e.target.value;
            setPollOptionsInputs((state) => {
              const options = new Array(...state);
              const pos = state.indexOf(input);
              if (pos > -1) {
                options[pos] = { ...options[pos], value: value };
              }

              return [...options];
            });
          }}
          placeholder="Type an option"
        />
        <InputGroup.Append>
          <Button
            disabled={votesPoll !== 0}
            variant="outline-secondary"
            className="btn btn-icon "
            onClick={(e) => removeOptionInput(e, input)}
            disabled={pollOptionsInputs.length <= 2 || votesPoll !== 0}
          >
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </Button>
        </InputGroup.Append>
      </InputGroup>
    ));
  };

  const onSubmit = () => {
    
    if(!validateForm()){
      return false;
    }
    if (entity === "Post") {      
      createPollOnPost(        
        { ...pollCreated, options: pollOptionsInputs },
        dispatch
      );
    } else {
      dispatch(
        actions.createPoll({ ...pollCreated, options: pollOptionsInputs })
      );
    }
    onHide();
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <div>Attach a poll</div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {votesPoll !== 0 && (
              <div className="mb-10 justify-content-center alert alert-custom alert-light-danger">
                <div className="alert-text font-weight-bold text-center">
                  You can't edit a poll with votes
                </div>
              </div>
            )}
            {pollCreated  && pollCreated.error != undefined && pollCreated.error.trim().length > 0 && (
              <div className="mb-10 justify-content-center alert alert-custom alert-light-danger">
                <div className="alert-text font-weight-bold text-center">{pollCreated.error}</div>
              </div>
            )}
            <div className="row">
              <div className="col-3">
                <Form.Group controlId="pollId">
                  <Form.Label>ID</Form.Label>
                  <Form.Control
                    name="pollId"
                    type="text"
                    placeholder="ID is not editable"
                    readOnly
                  />
                </Form.Group>
              </div>
              <div className="row col-8 justify-content-end">
                <div class="mr-2">
                  <Form.Group controlId="formCategory">
                    <Form.Label>Days</Form.Label>
                    <Form.Control
                      as="select"
                      name="days"
                      value={pollCreated?.days}
                      onChange={(e) =>
                        setPollCreated({
                          ...pollCreated,
                          days: parseInt(e.target.value),
                        })
                      }
                      disabled={editPost}
                    >
                      {DAYS.map((day) => (
                        <option key={day.key}>{day.value}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
                <div class="mr-2">
                  <Form.Group controlId="formCategory">
                    <Form.Label>Hours</Form.Label>
                    <Form.Control
                      as="select"
                      name="hours"
                      value={pollCreated?.hours}
                      onChange={(e) =>
                        setPollCreated({
                          ...pollCreated,
                          hours: parseInt(e.target.value),
                        })
                      }
                      disabled={editPost}
                    >
                      {HOURS.map((hour) => (
                        <option key={hour.key}>{hour.value}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
                <div class="mr-2">
                  <Form.Group controlId="formCategory">
                    <Form.Label>Min</Form.Label>
                    <Form.Control
                      as="select"
                      name="minutes"
                      value={pollCreated?.minutes}
                      onChange={(e) =>
                        setPollCreated({
                          ...pollCreated,
                          minutes: parseInt(e.target.value),
                        })
                      }
                      defaultValue
                      disabled={editPost}
                    >
                      {MINUTES.map((minute) => (
                        <option key={minute.key}>{minute.value}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </div>
            </div>
            <Form.Group controlId="pollText">
              <Form.Label>Text</Form.Label>
              <Form.Control
                required
                as="textarea"
                name="body"
                disabled={votesPoll !== 0}
                value={pollCreated?.body}
                onChange={(e) =>
                  setPollCreated({
                    ...pollCreated,
                    body: e.target.value,
                  })
                }
                rows={3}
              />
            </Form.Group>
            {renderOptionsInput()}
            <div className="row">
              <div className="col-6 d-flex justify-content-start">
                <Button
                  disabled={votesPoll !== 0}
                  onClick={addOptionInput}
                  disabled={pollOptionsInputs.length >= 6 || votesPoll !== 0}
                >
                  Add new option
                </Button>
              </div>
             
              <div className="col-6 d-flex justify-content-end ">
                <Button className="btn btn-secondary mr-2" onClick={onHide}>
                  Cancel
                </Button>                

                <Button disabled={votesPoll !== 0 } onClick={() => onSubmit()}>
                  Done
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(PollCreatorDialog);
